export const POSITION = {
  START: 'start',
  MIDDLE: 'middle',
  END: 'end',
};

export const ZERO_WIDTH_SPACE = '\u200b';
